// extracted by mini-css-extract-plugin
export var bodyRow = "_fz-d";
export var cardColumns = "_fz-e";
export var ellipsesOverflow = "_fz-2";
export var flatBottomCorners = "_fz-3";
export var flatTopCorners = "_fz-4";
export var headerActionsDropdown = "_fz-f";
export var headerBottomRow = "_fz-c";
export var headerTopRow = "_fz-b";
export var orderDetailsWrapper = "_fz-0";
export var orderInfoContainer = "_fz-1";
export var productDetails = "_fz-9";
export var productImage = "_fz-5";
export var responsiveTable = "_fz-8";
export var shipmentContainer = "_fz-a";
export var tableBottomLeft = "_fz-6";
export var tableBottomRight = "_fz-7";
export var trackingLink = "_fz-g";